import { CalendarEventPreview } from "components/calendar-event-preview";

import { useMicrosoftGraphEvent } from "data/use-microsoft-graph-event";
import { getMicrosoftGraphEventIntegration } from "utils/followup-integrations";

export const FollowupTask = ({ followup }) => {
  const graph = getMicrosoftGraphEventIntegration(followup);

  const { event, isLoading, error } = useMicrosoftGraphEvent({
    id: graph?.eventId,
    userId: graph?.userId,
    enabled: Boolean(graph?.eventId),
  });

  if (!graph) return null;

  if (event) {
    return <CalendarEventPreview event={event} />;
  }

  if (isLoading) {
    return <span>Loading calendar event...</span>;
  }

  if (error) {
    return <span style={{ opacity: 0.7 }}>Unable to load calendar event.</span>;
  }

  return <span style={{ opacity: 0.7 }}>Calendar event unavailable.</span>;
};
